/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */


const theme = {
  appearances: { inverse: { type: 'variant', values: [ true ] } },
  rules: [
    {
      if: { inverse: true },
      tokens: { backgroundColor: '#ffffff', color: '#414547' }
    }
  ],
  tokens: {
    arrowBorderRadius: 1,
    arrowOffset: 4,
    arrowWidth: 16,
    backgroundColor: '#2c2e30',
    borderRadius: 8,
    color: '#ffffff',
    fontName: 'HNforTELUSSA',
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 1.5,
    maxWidth: 288,
    minWidth: 0,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    shadow: {
      blur: 8,
      color: 'rgba(0, 0, 0, 0.1)',
      inset: false,
      offsetX: 0,
      offsetY: 4,
      spread: 0
    }
  }
}
export default theme
